<template>
  <div class="bot-nav -wrapper-between -wrapper-v-center -bg-lightgray-4 -border-top -px-5" style="z-index: 10;">
    <div class="-wrapper-h-v-center">
      <g-dropdown
        direction="up-left"
        v-model="value"
        text-class="-mx-0 -color-gray-1 -bg-transparent -font-weight-medium">
        <g-dropdown-item-wrap direction="up-left">
          <div>
            <g-dropdown-item value="ko" text="한국어" />
          </div>
          <!--
          <div>
            <g-dropdown-item value="en" text="English" />
          </div>
          <div>
            <g-dropdown-item value="zh-CN" text="简体中文" />
          </div>
          <div>
            <g-dropdown-item value="ja" text="日本語" />
          </div>
          -->
        </g-dropdown-item-wrap>
      </g-dropdown>
    </div>
    <div class="-wrapper-h-v-center">
      <g-button
        variant="borderless"
        class="-mx-0 -color-gray-1 -bg-transparent"
        @click="onClickServiceAgreement">
        <span>서비스 이용약관</span>
      </g-button>
      <span class="-border-left -font-size-11 -mx-2">&nbsp;</span>
      <g-button
        variant="borderless"
        class="-mx-0 -color-gray-1 -bg-transparent"
        @click="onClickPrivacyPolicy">
        <strong><span style="color: #eedd22">개인정보 처리방침</span></strong>
      </g-button>
      <span class="-border-left -font-size-11 -mx-2">&nbsp;</span>
      <g-button
        variant="borderless"
        class="-mx-0 -color-gray-1 -bg-transparent"
        @click="onClickTechnicalSupport">
        <span>기술 지원</span>
      </g-button>
      <p class="-px-2 -font-size-11 -color-gray-2">Copyright © 2020 OpsNow All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
import VueCookie from 'vue-cookies'
import { LOCALE_COOKIE_NAME } from '@/constants/constants'
import {footerChangeLang} from "@/utils/validation";
export default {
  name: 'g-footer',
  data () {
    return {
      value: ''
    }
  },
  methods: {
    onClickServiceAgreement () {
      this.$router.push('/terms/service')
    },
    onClickPrivacyPolicy () {
      this.$router.push('/terms/privacy-policy')
    },
    onClickTechnicalSupport () {
      window.open('https://support.bespinglobal.com/support/home')
    }
  },
  watch: {
    value () {
      this.$emit('change', this.value)
      VueCookie.set(LOCALE_COOKIE_NAME, this.value, '30d', '/', 'opsnow.com')

      footerChangeLang(this.value)
    }
  },
  beforeMount () {
    this.value = VueCookie.get(LOCALE_COOKIE_NAME) || 'ko'
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/layout/components/GFooter.vue